import { CommonModule, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../environments/environment';
import Swal from 'sweetalert2';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-create-documento-cargado',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './create-documento-cargado.component.html',
  styleUrl: './create-documento-cargado.component.css',
})
export class CreateDocumentoCargadoComponent implements OnInit {
  idDocumento: number = 0;
  documentoData: any = {};
  nombre: string = '';
  linkArchivo: string = '';
  idInstitucionEducativa: number = 0;
  errorArchivo: string = ''; // Variable para almacenar errores de archivo

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.idDocumento = params['id_documento'];
      this.fetchDocumentoData();
    });
    this.loadUserData();
  }

  loadUserData(): void {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      this.idInstitucionEducativa = user.id_institucion_educativa || 0;
    } else {
      console.error('No se encontró información de usuario en localStorage.');
    }
  }

  fetchDocumentoData(): void {
    this.http
      .get(environment.apiUrl + `/documento/${this.idDocumento}`)
      .subscribe(
        (data: any) => {
          this.documentoData = {
            nombre: data.nombre,
            descripcion: data.descripcion,
            tipo_documento: data.tipo_documento,
            fecha_inicio: data.fecha_inicio
              ? data.fecha_inicio.split('T')[0]
              : '',
            fecha_fin: data.fecha_fin ? data.fecha_fin.split('T')[0] : '',
            link_formato: data.link_formato,
            oficina: data.oficina.nombre,
            unidadFuncional: data.oficina.unidadFuncional.nombre,
          };
        },
        (error) => console.error('Error al obtener datos del documento:', error)
      );
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.errorArchivo = ''; // Limpiar mensajes de error previos

    if (input.files && input.files[0]) {
      const file = input.files[0];
      const formData = new FormData();
      formData.append('file', file);

      this.http
        .post<{ url: string }>(
          environment.apiUrl +
            '/archivo?fileName=' +
            this.idDocumento +
            '_' +
            this.idInstitucionEducativa,
          formData
        )
        .subscribe(
          (response) => {
            this.linkArchivo = environment.serverUrl + response.url; // Asigna el link del archivo al input
            //alert('Archivo subido con éxito');
          },
          (error) => {
            console.error('Error al subir el archivo:', error);
            this.errorArchivo =
              error.error.message || 'Error al subir el archivo.';
          }
        );
    }
  }

  saveDocumentoCargado(): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Quieres registrar el documento?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, registrar',
      cancelButtonText: 'No, cancelar',
    }).then((result) => {
      if (result.isConfirmed) {
        const payload = {
          link_archivo: this.linkArchivo,
          id_documento: this.idDocumento,
          id_institucion_educativa: this.idInstitucionEducativa,
        };

        this.http
          .post(environment.apiUrl + '/documento-cargado', payload)
          .subscribe(
            (response: any) => {
              this.registrarHistorial(
                'INICIADO',
                this.linkArchivo,
                response.id_documento_cargado
              );
              Swal.fire({
                icon: 'success',
                title: 'Éxito',
                text: 'El documento se ha cargado correctamente.',
              }).then(() => {
                this.router.navigate(['/documentos-institucion']);
              });
            },
            (error) => {
              //console.error('Error al registrar el documento:', error);
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text:
                  error.error.message ||
                  'Hubo un error al registrar el documento.',
              });
            }
          );
      }
    });
  }

  registrarHistorial(
    estado: string,
    link_archivo: string,
    id_documento_cargado: number
  ): void {
    const body = {
      accion: estado,
      link_archivo: link_archivo,
      id_documento_cargado: id_documento_cargado,
    };

    this.http
      .post(environment.apiUrl + '/historial-institucion', body)

      .subscribe(
        (response) => {
          //console.log('Historial registrado con éxito:', response);
        },
        (error) => {
          console.error('Error al registrar el historial:', error);
        }
      );
  }

  goBack(): void {
    this.router.navigate(['/documentos-institucion']);
  }
}
